(function () {
  const ROOT_ID = 'mexzy-beauty-root';
  const SEARCH_KEYWORDS = {
    easy: ['cleanser', 'wash', 'serum', 'essence', 'moistur', 'cream', 'lotion'],
    day: ['spf', 'sunscreen', 'uv', 'vitamin c', 'brighten', 'gel'],
    night: ['retinol', 'bakuchiol', 'peptide', 'repair', 'sleep', 'balm', 'exfol', 'aha', 'bha', 'peel'],
    exec: ['multi', 'all-in-one', 'all in one', 'serum', 'cream'],
    hair: ['hair', 'shampoo', 'conditioner', 'scalp'],
    neck: ['neck', 'décol', 'decol', 'firm', 'lift', 'sag', 'contour', 'jaw'],
  };

  function $(sel, el) { return (el || document).querySelector(sel); }
  function el(tag, cls) { const e = document.createElement(tag); if (cls) e.className = cls; return e; }

  function render(container) {
    const store = container.dataset.store || window.location.host;
    const token = container.dataset.token || '';
    container.innerHTML = '';

    const header = el('div', 'mxz-card');
    header.innerHTML = '<div class="mxz-flex"><div><strong>MEXZY Beauty Scan</strong></div><div class="mxz-muted">On‑device analysis. No upload.</div></div>';
    container.appendChild(header);

    const form = el('div', 'mxz-row');
    form.innerHTML = `
      <div class="mxz-col">
        <div class="mxz-field">
          <label>Gender</label>
          <select class="mxz-select" id="mxz-gender">
            <option value="preferNotToSay">Prefer not to say</option>
            <option value="female">Female</option>
            <option value="male">Male</option>
            <option value="nonbinary">Non‑binary</option>
          </select>
        </div>
      </div>
      <div class="mxz-col">
        <div class="mxz-field">
          <label>Skin type (optional)</label>
          <select class="mxz-select" id="mxz-skin">
            <option value="">Not sure</option>
            <option value="oily">Oily</option>
            <option value="dry">Dry</option>
            <option value="normal">Normal</option>
            <option value="combination">Combination</option>
            <option value="sensitive">Sensitive</option>
          </select>
        </div>
      </div>
      <div class="mxz-col">
        <div class="mxz-field">
          <label>Age range</label>
          <select class="mxz-select" id="mxz-age">
            <option value="18–25">18–25</option>
            <option value="26–35" selected>26–35</option>
            <option value="36–45">36–45</option>
            <option value="46–60">46–60</option>
            <option value=">60">&gt;60</option>
          </select>
        </div>
      </div>
    `;
    container.appendChild(form);

    const preview = el('div', 'mxz-card');
    preview.innerHTML = `
      <div class="mxz-muted">Center your face, ensure good lighting.</div>
      <div class="mxz-videoWrap" style="margin-top:8px;">
        <video id="mxz-video" autoplay playsinline></video>
        <div id="mxz-scanfx" class="mxz-scanfx hidden">
          <div class="mxz-scanfx__line"></div>
          <div class="mxz-scanfx__status">
            <div class="mxz-scanfx__progress"><div class="mxz-scanfx__bar"></div></div>
            <div class="mxz-scanfx__text">Scanning... 0%</div>
          </div>
        </div>
      </div>
      <canvas id="mxz-canvas" class="mxz-hidden"></canvas>
    `;
    container.appendChild(preview);

    const actions = el('div', 'mxz-actions');
    actions.innerHTML = `<button class="mxz-button" id="mxz-scan">Scan &amp; Recommend</button>`;
    container.appendChild(actions);
    const results = el('div', '');
    results.innerHTML = `
      <div class="mxz-card" id="mxz-summary">
        <strong>Analysis Summary</strong>
        <div class="mxz-muted">Pigmentation, dark circles, redness, pores, fine lines</div>
        <div id="mxz-spiral" style="margin-top:8px;"></div>
        <div id="mxz-scores" style="margin-top:8px;"></div>
      </div>
      <div class="mxz-card" id="mxz-recos">
        <strong>Recommendations</strong>
        <details class="mxz-collapse"><summary>Easy 3‑step beauty</summary><ul class="mxz-list" id="mxz-easy"></ul></details>
        <details class="mxz-collapse"><summary>Day‑time care</summary><ul class="mxz-list" id="mxz-day"></ul></details>
        <details class="mxz-collapse"><summary>Night care</summary><ul class="mxz-list" id="mxz-night"></ul></details>
        <details class="mxz-collapse"><summary>For executive</summary><ul class="mxz-list" id="mxz-exec"></ul></details>
        <details class="mxz-collapse"><summary>Neck / Firming</summary><ul class="mxz-list" id="mxz-neck"></ul></details>
        <details class="mxz-collapse"><summary>Hair specific</summary><ul class="mxz-list" id="mxz-hair"></ul></details>
      </div>
    `;
    container.appendChild(results);

    // Camera init
    const video = $('#mxz-video', container);
    navigator.mediaDevices.getUserMedia({ video: { facingMode: 'user' }, audio: false })
      .then(stream => { video.srcObject = stream; })
      .catch(() => { $('#mxz-scan', container).disabled = true; });

    $('#mxz-scan', container).addEventListener('click', async () => {
      // Start scanning effect
      const fx = $('#mxz-scanfx', container);
      const bar = $('#mxz-scanfx .mxz-scanfx__bar', container);
      const text = $('#mxz-scanfx .mxz-scanfx__text', container);
      if (fx && bar && text) {
        fx.classList.remove('hidden'); fx.classList.remove('done');
        let p = 0;
        text.textContent = 'Scanning... 0%';
        bar.style.width = '0%';
        const tick = setInterval(() => {
          p = Math.min(92, p + 3);
          bar.style.width = p + '%';
          text.textContent = 'Scanning... ' + p + '%';
        }, 120);
        // Capture + analysis
      const canvas = $('#mxz-canvas', container);
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(video, 0, 0);
      const scores = analyze(canvas);
      renderScores(scores, $('#mxz-scores', container));
      renderSpiral(scores, $('#mxz-spiral', container));
      const groups = await fetchRecommendations(store, token, scores);
      fillList($('#mxz-easy', container), groups.easy);
      fillList($('#mxz-day', container), groups.day);
      fillList($('#mxz-night', container), groups.night);
      fillList($('#mxz-exec', container), groups.exec);
      fillList($('#mxz-neck', container), groups.neck);
      fillList($('#mxz-hair', container), groups.hair);
        // Finish scanning effect
        clearInterval(tick);
        bar.style.width = '100%';
        fx.classList.add('done');
        text.textContent = 'Analysis complete';
        setTimeout(() => { fx.classList.add('hidden'); }, 600);
      }
      // Expand groups so items are visible even if <details> is disabled by theme CSS/JS
      ['easy','day','night','exec','neck','hair'].forEach(function(id){
        var ul = document.getElementById('mxz-' + id);
        if (ul && ul.parentElement && ul.parentElement.tagName && ul.parentElement.tagName.toLowerCase() === 'details') {
          ul.parentElement.setAttribute('open','open');
        }
      });
      const summaryEl = document.getElementById('mxz-summary');
      if (summaryEl && summaryEl.scrollIntoView) {
        setTimeout(() => { try{ summaryEl.scrollIntoView({behavior:'smooth', block:'start'});}catch(e){} }, 50);
      }
    });
  }

  function analyze(canvas) {
    // Heuristic similar to the Flutter version: compute region stats
    const w = canvas.width, h = canvas.height;
    const ctx = canvas.getContext('2d');
    const full = ctx.getImageData(0, 0, w, h).data;

    function region(x, y, rw, rh) {
      x = Math.max(0, Math.floor(x)); y = Math.max(0, Math.floor(y));
      rw = Math.min(w - x, Math.floor(rw)); rh = Math.min(h - y, Math.floor(rh));
      let sumY = 0, sumY2 = 0, sumR = 0, sumG = 0, sumB = 0, c = 0;
      for (let j = y; j < y + rh; j += 2) {
        for (let i = x; i < x + rw; i += 2) {
          const idx = (j * w + i) * 4;
          const r = full[idx], g = full[idx + 1], b = full[idx + 2];
          const Y = 0.2126 * r + 0.7152 * g + 0.0722 * b;
          sumR += r; sumG += g; sumB += b; sumY += Y; sumY2 += Y * Y; c++;
        }
      }
      const meanY = sumY / Math.max(1, c);
      const varY = Math.max(0, sumY2 / Math.max(1, c) - meanY * meanY);
      const stdY = Math.sqrt(varY);
      return { meanR: sumR / c, meanG: sumG / c, meanB: sumB / c, meanY, stdY };
    }
    const roi = { x: w * 0.2, y: h * 0.15, rw: w * 0.6, rh: h * 0.7 };
    const t = region(roi.x + roi.rw * 0.35, roi.y + roi.rh * 0.1, roi.rw * 0.3, roi.rh * 0.5);
    const u = region(roi.x + roi.rw * 0.1, roi.y + roi.rh * 0.55, roi.rw * 0.8, roi.rh * 0.35);
    const under = region(roi.x + roi.rw * 0.2, roi.y + roi.rh * 0.55, roi.rw * 0.6, roi.rh * 0.2);
    const face = region(roi.x, roi.y, roi.rw, roi.rh);

    const redness = Math.max(0, Math.min(1, (face.meanR - (face.meanG + face.meanB) / 2) / 255));
    const darkCircles = Math.max(0, Math.min(1, (u.meanY - under.meanY) / 100));
    const pores = Math.max(0, Math.min(1, t.stdY / 64));
    const fineLines = Math.max(0, Math.min(1, under.stdY / 64));
    const pigmentation = Math.max(0, Math.min(1, face.stdY / 64));
    return { pigmentation, dark_circles: darkCircles, redness, pores, fine_lines: fineLines };
  }

  function renderScores(scores, host) {
    const entries = Object.entries(scores);
    host.innerHTML = entries.map(([k, v]) =>
      `<span class="mxz-chip">${label(k)}: ${(v * 100).toFixed(0)}%</span> `
    ).join('');
  }

  function renderSpiral(scores, host) {
    const order = ['pigmentation', 'dark_circles', 'redness', 'pores', 'fine_lines'];
    const size = 260, cx = size / 2, cy = size / 2, R = size * 0.42;
    const pts = order.map((k, i) => {
      const v = Math.min(1, Math.max(0, scores[k] || 0));
      const eased = 0.15 + 0.85 * v;
      const ang = (2 * Math.PI / order.length) * i - Math.PI / 2;
      const r = R * eased;
      return [cx + Math.cos(ang) * r, cy + Math.sin(ang) * r];
    });
    const pathD = 'M ' + pts.map(p => p.join(',')).join(' L ') + ' Z';
    host.innerHTML = `
      <svg width="${size}" height="${size}">
        <circle cx="${cx}" cy="${cy}" r="${R*0.2}" fill="none" stroke="#e5e7eb"/>
        <circle cx="${cx}" cy="${cy}" r="${R*0.4}" fill="none" stroke="#e5e7eb"/>
        <circle cx="${cx}" cy="${cy}" r="${R*0.6}" fill="none" stroke="#e5e7eb"/>
        <circle cx="${cx}" cy="${cy}" r="${R*0.8}" fill="none" stroke="#e5e7eb"/>
        <circle cx="${cx}" cy="${cy}" r="${R}" fill="none" stroke="#e5e7eb"/>
        <path d="${pathD}" fill="url(#g1)" stroke="#26C6DA" stroke-width="2"/>
        <defs>
          <linearGradient id="g1" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stop-color="#2196F3" stop-opacity="0.2"/>
            <stop offset="100%" stop-color="#26C6DA" stop-opacity="0.2"/>
          </linearGradient>
        </defs>
      </svg>
    `;
  }

  function label(k) {
    switch (k) {
      case 'pigmentation': return 'Pigment';
      case 'dark_circles': return 'Dark Circles';
      case 'redness': return 'Redness';
      case 'pores': return 'Pores';
      case 'fine_lines': return 'Fine Lines';
      default: return k;
    }
  }

  // Build personalized keyword sets using scan issues and selected skin type
  function getSelectedSkin() {
    const el = document.getElementById('mxz-skin');
    return el && typeof el.value === 'string' ? el.value : '';
  }

  function getSelectedAge() {
    const el = document.getElementById('mxz-age');
    return el && typeof el.value === 'string' ? el.value : '';
  }

  function uniq(arr) {
    const out = [];
    const seen = new Set();
    for (const v of arr) {
      const k = String(v || '').trim().toLowerCase();
      if (!k) continue;
      if (!seen.has(k)) { seen.add(k); out.push(k); }
    }
    return out;
  }

  function aliasExpand(list) {
    const aliases = {
      moisturizer: ['moisturiser'],
      moistur: ['moisturiser', 'moisturizer'],
      'vitamin c': ['vit c', 'ascorbic'],
      bha: ['salicylic'],
      aha: ['glycolic', 'lactic'],
      retinol: ['retinoid'],
      'non-comedogenic': ['non comedogenic', 'noncomedogenic'],
      sunscreen: ['spf'],
      peptide: ['peptides'],
      ceramide: ['ceramides'],
    };
    const out = [];
    for (const term of list || []) {
      out.push(term);
      const key = String(term || '').toLowerCase();
      const extra = aliases[key];
      if (extra && extra.length) out.push(...extra);
    }
    return uniq(out);
  }

  function expandGroupKeywords(groups) {
    return {
      easy: aliasExpand(groups.easy || []),
      day: aliasExpand(groups.day || []),
      night: aliasExpand(groups.night || []),
      exec: aliasExpand(groups.exec || []),
      neck: aliasExpand(groups.neck || []),
      hair: aliasExpand(groups.hair || []),
    };
  }

  function buildPersonalizedKeywords(scores, skin, age) {
    const pairs = Object.entries(scores || {}).sort((a, b) => (b[1] || 0) - (a[1] || 0));
    const topIssues = pairs.map(p => p[0]).slice(0, 3);

    const issueMap = {
      pigmentation: ['brighten', 'dark spot', 'vitamin c', 'niacinamide', 'tranexamic', 'alpha arbutin'],
      redness: ['soothing', 'calming', 'azelaic', 'centella', 'cica', 'allantoin'],
      dark_circles: ['eye cream', 'caffeine', 'niacinamide', 'retinol eye'],
      pores: ['salicylic', 'bha', 'pore', 'niacinamide', 'clay'],
      fine_lines: ['retinol', 'peptide', 'bakuchiol', 'hyaluronic', 'ceramide']
    };
    const skinMap = {
      oily: ['oil control', 'gel', 'lightweight', 'non-comedogenic', 'mattifying'],
      dry: ['moisturizer', 'cream', 'hydrating', 'hyaluronic', 'ceramide', 'shea'],
      normal: ['balanced', 'moisturizer'],
      combination: ['balancing', 'lightweight', 'gel cream'],
      sensitive: ['fragrance free', 'soothing', 'cica', 'centella', 'barrier']
    };

    const ageMap = {
      '18–25': ['gentle', 'gel', 'niacinamide', 'sunscreen'],
      '26–35': ['niacinamide', 'hyaluronic', 'sunscreen'],
      '36–45': ['peptide', 'retinol', 'hyaluronic', 'ceramide', 'firming'],
      '46–60': ['peptide', 'retinol', 'ceramide', 'firming', 'lifting'],
      '>60': ['peptide', 'retinoid', 'ceramide', 'firming', 'lifting', 'rich cream']
    };

    function mix(base, group) {
      const arr = [];
      if (Array.isArray(base)) arr.push(...base);
      const ageTerms = ageMap[age] || [];
      // For day/night, emphasize issue-derived terms immediately after base
      if (group === 'day' || group === 'night') {
        // Age terms early for daytime/nighttime regimens
        if (ageTerms.length) arr.push(...ageTerms);
        for (const issue of topIssues) arr.push(...(issueMap[issue] || []));
      }
      if (skinMap[skin]) arr.push(...skinMap[skin]);
      // For other groups, append issue-derived terms later
      if (group !== 'day' && group !== 'night') {
        if (ageTerms.length) arr.push(...ageTerms);
        for (const issue of topIssues) arr.push(...(issueMap[issue] || []));
      }
      // Add explicit "for <skin> skin" variants near the end (if present)
      if (skin) arr.push(`for ${skin} skin`);
      return uniq(arr).slice(0, 20);
    }

    return {
      easy: mix(['cleanser', 'serum', 'moisturizer', 'essence', 'lotion'], 'easy'),
      day: mix(['sunscreen', 'spf', 'vitamin c', 'brighten', 'gel'], 'day'),
      night: mix(['retinol', 'peptide', 'repair', 'sleep', 'balm', 'bakuchiol'], 'night'),
      exec: mix(['all-in-one', 'multi', 'serum', 'cream'], 'exec'),
      neck: uniq(['neck', 'firm', 'lift', 'sag', 'contour', 'jaw']),
      hair: uniq(['hair', 'shampoo', 'conditioner', 'scalp'])
    };
  }

  // Token-less recommendations using storefront predictive search (no app/token)
  async function fetchRecommendations(store, _token, _scores) {
    async function suggest(keyword, limit = 6) {
      const url = `/search/suggest.json?q=${encodeURIComponent(keyword)}&resources[type]=product&resources[limit]=${limit}`;
      try {
        const res = await fetch(url, {
          method: 'GET',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          credentials: 'same-origin'
        });
        if (!res || !res.ok) return [];
        const json = await res.json();
        const items = (((json || {}).resources || {}).results || {}).products || [];
        return items.map(p => {
          let price = '';
          if (typeof p.price === 'number') {
            try { price = (p.price / 100).toFixed(2); } catch(e){ price = String(p.price); }
          } else if (typeof p.price === 'string') {
            price = p.price;
          }
          return { name: p.title, url: p.url, price };
        });
      } catch {
        return [];
      }
    }

    async function pick(keywords) {
      for (const k of keywords) {
        const items = await suggest(k, 6);
        if (items.length) return items;
      }
      return [];
    }

    const skin = getSelectedSkin();
    const age = getSelectedAge();
    const dynamic = expandGroupKeywords(buildPersonalizedKeywords(_scores, skin, age));

    const easy = (await pick([...(dynamic.easy || []), ...SEARCH_KEYWORDS.easy])).slice(0, 3);
    const day  = (await pick([...(dynamic.day || []), ...SEARCH_KEYWORDS.day])).slice(0, 3);
    const night= (await pick([...(dynamic.night || []), ...SEARCH_KEYWORDS.night])).slice(0, 3);
    const exec = (await pick([...(dynamic.exec || []), ...SEARCH_KEYWORDS.exec])).slice(0, 3);
    const hair = (await pick([...(dynamic.hair || []), ...SEARCH_KEYWORDS.hair])).slice(0, 3);
    const neck = (await pick([...(dynamic.neck || []), ...SEARCH_KEYWORDS.neck])).slice(0, 5);
    return { easy, day, night, exec, hair, neck };
  }

  function fillList(ul, items) {
    if (!items || !items.length) {
      ul.innerHTML = `<li class="mxz-muted">No matches yet. Adjust keywords or ensure products are searchable.</li>`;
      return;
    }
    ul.innerHTML = items.map(function(i){
      var price = i.price ? `<span class="mxz-muted">• ${escapeHtml(i.price)}</span>` : '';
      return `<li><span>${escapeHtml(i.name)} ${price}</span><a class="mxz-link" href="${i.url}" target="_blank" rel="noopener">Open</a></li>`;
    }).join('');
  }

  function escapeHtml(s) { return s.replace(/[&<>"']/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m])); }

  document.addEventListener('DOMContentLoaded', () => {
    const root = document.getElementById(ROOT_ID);
    if (root) render(root);
  });
})();
